import { createFileRoute } from '@tanstack/react-router';
import { CreateProcessesPage } from '@/pages/processes/create-processes/CreateProcessesPage';

export const Route = createFileRoute('/$slug/processes/create-processes/')({
  component: CreateProcessesPage
});
